export const sourceRecordsFilter = (record) => {
    if (record.priceRounding != null) {
        {
            Object.keys(record.priceRounding).map(type => {
                if (record.priceRounding[type] == null) {
                    record.priceRounding[type] = '';
                } else if (typeof record.priceRounding[type] != 'string') {
                    record.priceRounding[type] = record.priceRounding[type].join('\n');
                }
            });
        }
    }
    return record;
};
